export default __webpack_public_path__ + "static/media/win-phone3.aa9979c6.png";